import { render, staticRenderFns } from "./add-price.vue?vue&type=template&id=3ed33650&scoped=true&"
import script from "./add-price.vue?vue&type=script&lang=js&"
export * from "./add-price.vue?vue&type=script&lang=js&"
import style0 from "./add-price.vue?vue&type=style&index=0&id=3ed33650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed33650",
  null
  
)

export default component.exports